import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UUID } from 'angular2-uuid';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { UserCreateComponent } from '../user-create/user-create.component';

@Component({
  selector: 'app-adsl-create',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./adsl-create.component.scss']
})
export class AdslCreateComponent extends UserCreateComponent implements OnInit {
  msgNotAuthenticatedByShahkar: string;
  accountSuccessfullyCreatedAndAuthenticated: string;
  portNotReserved: string;
  portNotRanje: string;
  provider: string;
  dslCenterId: number;
  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: UserService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.subentityName = 'adsl';

    translator.get([
      'PORT_NOT_RESERVED',
      'PORT_NOT_RANJE',
      'ACCOUNT_SUCCESSFULLY_CREATED_AND_AUTHENTICATED',
      'NOT_AUTHENTICATED_BY_SHAHKAR'
    ]).subscribe(
      translation => {
        this.msgNotAuthenticatedByShahkar = translation.NOT_AUTHENTICATED_BY_SHAHKAR;
        this.accountSuccessfullyCreatedAndAuthenticated = translation.ACCOUNT_SUCCESSFULLY_CREATED_AND_AUTHENTICATED;
        this.portNotReserved = translation.PORT_NOT_RESERVED;
        this.portNotRanje = translation.PORT_NOT_RANJE;
      });
  }

  getBody(): any {
    const body = super.getBody();
    body['vendor'] = this.provider;
    body['dsl_center_id'] = this.dslCenterId;
    return body;
  }

  getMeta(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const meta = await super.getMeta();
      if (!this.isEdit) {
        meta.fields.splice(meta.fields.findIndex(c => c.name === 'tags'), 0, {
          name: 'password',
          caption: this.translator.instant('PASSWORD'),
          value: UUID.UUID().substr(0, 8),
          type: {
            name: 'text',
            readOnly: true
          }
        });
        resolve(meta);
      } else {
        resolve(meta);
      }
    });
  }

  // async customValidation(data) {
  //   this.service.apiCall('api/user/inquiry_port', { username: data.username }).subscribe((result: any) => {
  //     if (result.ok) {
  //       const jsonResult = result.json();
  //       this.provider = jsonResult.provider;
  //       this.dslCenterId = jsonResult.dsl_center_id;
  //     } else {
  //       if (!this.validateLog.find(i => i.validate.message === 'NOT_AVAILABLE')) {
  //         this.validateLog.push({ item: 'tel', validate: { message: 'NOT_AVAILABLE' } });
  //       }
  //     }
  //   }, error => {
  //     if (!this.validateLog.find(i => i.validate.message === 'NOT_AVAILABLE')) {
  //       this.validateLog.push({ item: 'tel', validate: { message: 'NOT_AVAILABLE' } });
  //     }
  //   });
  // }

  validateItem() {
    this.validateLog = this.validateLog.filter(i => i.validate.message === 'NOT_AVAILABLE');

    this.customValidation(this.formData);
    this.fields.forEach(item => {
      if (item.rules) {
        item.rules.forEach(element => {
          if (item.name === 'tel_owner_nc' || item.name === 'username') {

          }
          if (element.validate(this.formData[item.name]).message) {
            this.validateLog.push(
              {
                item: item.label ? item.label.toUpperCase() : item.name.toUpperCase(),
                validate: element.validate(this.formData[item.name])
              });
          }
        });
      }
    });
    return this.validateLog.length > 0 ? false : true;
  }

  async valueChanged(e) {
    if (e.element.id === 'username') {
      this.validateLog = [];
      if (e.value && e.value.length >= 10) {
        this.service.apiCall('api/user/inquiry_port', { username: e.value }).subscribe((result: any) => {
          this.provider = result.provider;
          this.dslCenterId = result.dsl_center_id;
        }, error => {
          if (!this.validateLog.find(i => i.validate.message === 'NOT_AVAILABLE')) {
            this.validateLog.push({ item: 'tel', validate: { message: 'NOT_AVAILABLE' } });
          }
        });

      }
    }

  }

}
